'use strict';/*jslint ts:true, react:true*/
import React from 'react';
import {Root as Blog2_root} from '../pages/hola.org/blog2';
import {Root as Article_root} from '../pages/hola.org/blog/article';
import {Editor} from '../../../shared/editor/editor';

export interface i_blog {
    category?: string;
    per_page?: number;
    page?: number;
    title?: string;
    slug?: string;
    id?: string;
}

interface i_blog_editor_props {
    value: i_blog;
    on_change: (v: i_blog)=>void;
}

export const Blog = (props: i_blog)=>{
    // If props indicate an article slug/id, delegate to Article viewer
    // @ts-ignore
    if ((props as any).slug)
        return <Article_root {...props as any}/>;
    return <Blog2_root {...props as any}/>;
};

export const Blog_editor = (props: i_blog_editor_props)=>{
    const {value = {category: '', per_page: 9, page: 1, title: ''},
        on_change} = props;
    type editor_key = keyof i_blog;
    type editor_type = 'text'|'number'|'selector'|'boolean'|'textarea';
    const editors: {key: editor_key; label: string; type: editor_type}[] = [
        ['title', 'Block title', 'text'],
        ['category', 'Category', 'text'],
        ['per_page', 'Items per page', 'number'],
        ['page', 'Page', 'number'],
    ].map(([k, label, type])=>({key: k as editor_key, label,
        type: type as editor_type}));
    return <Editor value={value as any} editors={editors} on_change={on_change}
      title="Blog"/>;
};
